import {
  changeDiscrepancySummaries,
  getDiscrepancySummaries,
  DiscrepancySummaryActionType,
} from '../ducks/discrepancySummary';
import {LoadingAdditional, AsyncResult, fromResult, Loading} from 'Core/models/Async';
import {put, call, takeLatest, all} from '@redux-saga/core/effects';
import {Page} from 'Core/models/Page';
import {DiscrepancySummary} from '../models/AccountDetail';
import {mergeWithNextPage} from 'Shared/utilities/PageUtility';
import accountApi from '../api/accountApi';
import {pipe} from 'fp-ts/lib/pipeable';
import * as E from 'fp-ts/lib/Either';

export function* getDiscrepancySummariesFromApi(action: ReturnType<typeof getDiscrepancySummaries>) {
  if (action.payload.page) {
    yield put(changeDiscrepancySummaries(new LoadingAdditional(action.payload.page)));
  } else {
    yield put(changeDiscrepancySummaries(new Loading(action.payload.page)));
  }

  const result: AsyncResult<Page<DiscrepancySummary>> = yield action.payload.page
    ? call(mergeWithNextPage, {existingPage: action.payload.page})
    : call(
        accountApi.getDiscrepancySummaries,
        action.payload.encryptedIdentifier,
        action.payload.accountNumber,
        action.payload.sourceId,
        action.payload.paymentDate,
        action.payload.discrepancySummaryFilter
      );

  yield pipe(
    result,
    E.map(fromResult),
    E.fold(
      value => put(changeDiscrepancySummaries(value)),
      value => put(changeDiscrepancySummaries(value))
    )
  );
}

export function* fetchDiscrepancySummariesSaga() {
  yield takeLatest(DiscrepancySummaryActionType.GET_DISCREPANCY_SUMMARIES, getDiscrepancySummariesFromApi);
}

export default function*() {
  yield all([fetchDiscrepancySummariesSaga()]);
}
